<app-view-profile *ngIf="profileAction == 'view'"></app-view-profile>
<!-- <app-edit-profile *ngIf="profileAction == 'edit'"></app-edit-profile> -->